module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon4.3672289c.svg";